import { render, staticRenderFns } from "./simplicity_template.vue?vue&type=template&id=3532bcf3&"
import script from "./simplicity_template.vue?vue&type=script&lang=js&"
export * from "./simplicity_template.vue?vue&type=script&lang=js&"
import style0 from "./simplicity_template.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports